"use client";
import { useGroup } from "../group/group.js";
import { createElement, createHook, forwardRef } from "@ariakit/react-utils";
//#region src/composite/composite-group.tsx
const TagName = "div";
/**
* Returns props to create a `CompositeGroup` component.
* @see https://ariakit.com/components/composite
* @example
* ```jsx
* const store = useCompositeStore();
* const props = useCompositeGroup({ store });
* <Composite store={store}>
*   <Role {...props}>
*     <CompositeGroupLabel>Label</CompositeGroupLabel>
*     <CompositeItem>Item 1</CompositeItem>
*     <CompositeItem>Item 2</CompositeItem>
*   </Role>
* </Composite>
* ```
*/
const useCompositeGroup = createHook(function useCompositeGroup({ store, ...props }) {
	props = useGroup(props);
	return props;
});
/**
* Renders a group element for composite items. The
* [`CompositeGroupLabel`](https://ariakit.com/reference/composite-group-label)
* component can be used inside this component so the `aria-labelledby` prop is
* properly set on the group element.
* @see https://ariakit.com/components/composite
* @example
* ```jsx {3-7}
* <CompositeProvider>
*   <Composite>
*     <CompositeGroup>
*       <CompositeGroupLabel>Label</CompositeGroupLabel>
*       <CompositeItem>Item 1</CompositeItem>
*       <CompositeItem>Item 2</CompositeItem>
*     </CompositeGroup>
*   </Composite>
* </CompositeProvider>
* ```
*/
const CompositeGroup = forwardRef(function CompositeGroup(props) {
	return createElement(TagName, useCompositeGroup(props));
});
//#endregion
export { CompositeGroup, useCompositeGroup };

//# sourceMappingURL=composite-group.js.map